import { StyleSheet } from 'react-native';
import { Device } from 'DeviceUtils';
import Theme from 'Theme';

export const DEFAULT_BOTTOM = -1000;

export const defaultStyles = {
    outerContainer: {
        position: 'absolute',
        bottom: DEFAULT_BOTTOM
    },
    innerContainer: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'flex-start',
        backgroundColor: 'rgba(255, 255, 255, 0.95)',
        borderColor: 'rgba(255, 255, 255, 0.95)',
        borderTopLeftRadius: 4,
        borderTopRightRadius: 4,
        borderWidth: 1,
        padding: 20
    },
    icon: {
        width: 20,
        height: 20,
        marginRight: 10
    },
    message: {
        fontSize: 17,
        color: Theme.alertTextColor,
        fontFamily: Theme.regularFont
    }
};

if (Device.isWeb) {
    defaultStyles.outerContainer = {
        position: 'fixed',
        left: '50%'
    };
}

export default StyleSheet.create(defaultStyles);
